import { get, post } from './request'
import qs from 'qs'

const token = localStorage.getItem('token')

// 领奖
export const savaAdress = data => {
  return post(
    '/answer/address_save',
    qs.stringify({
      token,
      ...data
    })
  )
}

// 选择奖励
export const chooseAward = data => {
  return post(
    '/answer/prize_save',
    qs.stringify({
      token,
      ...data
    })
  )
}

// 查询奖品信息
export const getPrizeInfo = data => {
  return get('/answer/prize_info', {
    token,
    ...data
  })
}

// 排行榜
export const getRankList = data => {
  return get('/answer/group_rank', {
    ...data
  })
}

// 获取用户排名信息
export const getUserRankInfo = data => {
  return get('/answer/rank_group_user', {
    token,
    ...data
  })
}

// 获取用户答题记录
export const getUserRecordList = data => {
  return get('/answer/answer_record', {
    token,
    ...data
  })
}

// 复活
export const recover = data => {
  return get('/answer/recover', data)
}

// 获取复活次数
export const getRecoverInfo = data => {
  return get('/answer/recover_status', data)
}

// 获得答题次数
export const getAnserCount = data => {
  return get('/answer/answer_left', {
    token,
    ...data
  })
}

// 分享获得回答次数接口
export const getCountByShare = data => {
  return get('/answer/share_save', {
    token,
    ...data
  })
}

// 获取是否查看过
export const isViewd = data => {
  return get('/answer/view_status', {
    token
  })
}

// 设置获奖后查看过奖励
export const setViewed = data => {
  return get('/answer/prize_view', {
    token
  })
}
